module.exports = __webpack_public_path__ + "static/media/heading.defde573.svg";